import React, { useContext } from "react";
import { BaseList } from "./style";
import PropTypes from "prop-types";
import ListItem from "./ListItem";
import { ThemeContext } from "helpers/contexts.js";
import styled from "styled-components";
import { isMobile } from "components/globals";

List.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  maxHeight: PropTypes.string,
  isLoading: PropTypes.bool,
};
List.defaultProps = {
  isLoading: false,
  width: "100%",
  maxHeight: null,
  height: "auto",
};

function List(props) {
  const theme = useContext(ThemeContext);
  const isMobileMode = isMobile();
  const listBorderColor = theme.colors.gray.gray200;
  const listPadding = isMobileMode ? "16px 10px" : "12px 10px";
  let overflowY = null;
  if (props.height) {
    overflowY = `auto`;
  }

  const renderPlaceHolder = (theme) => {
    return (
      <>
        <ListItem
          hoverColor={theme.colors.transparent}
          activeColor={theme.colors.transparent}
          borderColor={listBorderColor}
          padding={listPadding}
        >
          <Placeholder
            bgColor={theme.colors.gray.gray400}
            width={"155px"}
            opacity={"0.5"}
          />
        </ListItem>
        <ListItem
          hoverColor={theme.colors.transparent}
          activeColor={theme.colors.transparent}
          borderColor={listBorderColor}
          padding={listPadding}
        >
          <Placeholder
            bgColor={theme.colors.gray.gray300}
            width={"120px"}
            opacity={"0.8"}
          />
        </ListItem>
        <ListItem
          hoverColor={theme.colors.transparent}
          activeColor={theme.colors.transparent}
          borderColor={listBorderColor}
          padding={listPadding}
        >
          <Placeholder
            bgColor={theme.colors.gray.gray300}
            width={"135px"}
            opacity={"0.6"}
          />
        </ListItem>
        <ListItem
          hoverColor={theme.colors.transparent}
          activeColor={theme.colors.transparent}
          borderColor={listBorderColor}
          padding={listPadding}
        >
          <Placeholder
            bgColor={theme.colors.gray.gray300}
            width={"95px"}
            opacity={"1"}
          />
        </ListItem>
        <ListItem
          hoverColor={theme.colors.transparent}
          activeColor={theme.colors.transparent}
          borderColor={listBorderColor}
          padding={listPadding}
        >
          <Placeholder
            bgColor={theme.colors.gray.gray100}
            width={"140px"}
            opacity={"1"}
          />
        </ListItem>
      </>
    );
  };

  return (
    <BaseList
      width={props.width}
      height={props.height}
      overflowY={overflowY}
      maxHeight={props.maxHeight}
    >
      {props.isLoading ? renderPlaceHolder(theme) : props.children}
    </BaseList>
  );
}

const Placeholder = styled.div`
  width: ${(props) => props.width};
  background: ${(props) => props.bgColor};
  opacity: ${(props) => props.opacity};
  height: 7px;
  border-radius: 7.5px;
  overflow: hidden;
`;

export default React.memo(List);
